if ( $('section#lender-header-signup').length ) {
  $(function(){
    /**
     * check lenders login cookie to display signup or signin CTA
     */
    if(isLoggedLender()){
      $('#lender-header-sign-up').addClass('d-none');
      $('#lender-header-sign-in').removeClass('d-none');
    }
  });
}
